// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `horizontal-scroll {
  --element-width: min(330px, 80vw);
  --side-margin: calc(2 * var(--motes-padding));
  --between-items-spacing: calc(2 * var(--motes-padding));
}
horizontal-scroll .horizontal-scroll .horizontal-header {
  font-size: 20px;
  font-weight: bold;
}
horizontal-scroll .horizontal-scroll .scroll-container {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  pointer-events: auto;
  scrollbar-width: none;
}
horizontal-scroll .horizontal-scroll .scroll-container > * {
  width: var(--element-width);
  min-width: 250px;
  border-radius: var(--border-radius);
  transition: 0.5s;
  display: inline-block;
  margin-left: var(--between-items-spacing);
  vertical-align: top;
}
horizontal-scroll .horizontal-scroll .scroll-container > *:first-child {
  margin-left: var(--safe-area-left);
}
horizontal-scroll .horizontal-scroll .scroll-container > *:last-child {
  margin-right: var(--safe-area-right);
}
horizontal-scroll .horizontal-scroll .scroll-container mini-mote:hover {
  transform: scale(1.05);
  transition: 0.2s;
}
horizontal-scroll .horizontal-scroll .scroll-container::-webkit-scrollbar {
  display: none;
}
horizontal-scroll .horizontal-scroll .hbo-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  color: var(--motes-white);
  padding: var(--motes-padding) var(--safe-area-right) var(--motes-padding) var(--safe-area-left);
}
horizontal-scroll .horizontal-scroll .hbo-container h3, horizontal-scroll .horizontal-scroll .hbo-container .arrows-container {
  margin: 5px 0;
}
horizontal-scroll .horizontal-scroll .hbo-container .arrows-container {
  display: flex;
  opacity: 1;
}
horizontal-scroll .horizontal-scroll .hbo-container .arrows-container svg-icon, horizontal-scroll .horizontal-scroll .hbo-container .arrows-container svg-icon > span {
  display: flex;
  align-items: center;
}
horizontal-scroll .horizontal-scroll .hbo-container .arrows-container .arrow {
  font-size: 35px;
  margin: 0 2.5px;
  cursor: pointer;
}
horizontal-scroll .horizontal-scroll .hbo-container .arrows-container .arrow.disable {
  cursor: default;
  pointer-events: none;
  opacity: 0.5;
}
horizontal-scroll .horizontal-scroll .hbo-container .arrows-container.hide {
  opacity: 0;
  pointer-events: none;
}
@media only screen and (max-width: 600px) {
  horizontal-scroll {
    --side-margin: var(--motes-padding);
    --between-items-spacing: var(--motes-padding);
  }
  horizontal-scroll .horizontal-scroll mini-mote:hover {
    transform: none;
  }
  horizontal-scroll .horizontal-scroll .hbo-container .arrows-container {
    display: none;
  }
  horizontal-scroll .horizontal-scroll .scroll-container > *:only-child {
    width: calc(100% - 2 * var(--side-margin));
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/horizontal-scroll/horizontal-scroll.component.scss"],"names":[],"mappings":"AAAA;EAEI,iCAAA;EACA,6CAAA;EACA,uDAAA;AAAJ;AAIQ;EACI,eAAA;EACA,iBAAA;AAFZ;AAKQ;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;AAHZ;AAMY;EACI,2BAAA;EACA,gBAAA;EACA,mCAAA;EACA,gBAAA;EACA,qBAAA;EACA,yCAAA;EACA,mBAAA;AAJhB;AAMgB;EACI,kCAAA;AAJpB;AAOgB;EACI,oCAAA;AALpB;AASY;EACI,sBAAA;EACA,gBAAA;AAPhB;AAYQ;EACI,aAAA;AAVZ;AAaQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,yBAAA;EACA,+FAAA;AAXZ;AAaY;EACI,aAAA;AAXhB;AAcY;EACI,aAAA;EACA,UAAA;AAZhB;AAegB;EACI,aAAA;EACA,mBAAA;AAbpB;AAgBgB;EACI,eAAA;EACA,eAAA;EACA,eAAA;AAdpB;AAiBgB;EACI,eAAA;EACA,oBAAA;EACA,YAAA;AAfpB;AAkBgB;EACI,UAAA;EACA,oBAAA;AAhBpB;AAuBI;EA7FJ;IA8FQ,mCAAA;IACA,6CAAA;EApBN;EAuBU;IACI,eAAA;EArBd;EAwBU;IACI,aAAA;EAtBd;EAyBU;IACI,0CAAA;EAvBd;AACF","sourcesContent":["horizontal-scroll {\n\n    --element-width: min(330px, 80vw);\n    --side-margin: calc(2 * var(--motes-padding));\n    --between-items-spacing: calc(2 * var(--motes-padding));\n    \n    .horizontal-scroll {\n        \n        .horizontal-header {\n            font-size: 20px;\n            font-weight: bold;\n        }\n\n        .scroll-container {\n            overflow-x: scroll;\n            overflow-y: hidden;\n            white-space: nowrap;\n            pointer-events: auto;\n            scrollbar-width: none; // Hide scrollbar in firefox\n    \n            // All elements in scroll container (for now mini-motes, motes-cards and mini-vouchers)\n            > * {\n                width: var(--element-width);\n                min-width: 250px;\n                border-radius: var(--border-radius);\n                transition: 0.5s;\n                display: inline-block;\n                margin-left: var(--between-items-spacing);\n                vertical-align: top;\n\n                &:first-child {\n                    margin-left: var(--safe-area-left);\n                }\n\n                &:last-child {\n                    margin-right: var(--safe-area-right);\n                }\n            }\n            \n            mini-mote:hover {\n                transform: scale(1.05);\n                transition: 0.2s;\n            }\n        }\n    \n        // Hide scrollbar everywhere but firefox\n        .scroll-container::-webkit-scrollbar {\n            display: none;\n        }\n    \n        .hbo-container {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            overflow: hidden;\n            color: var(--motes-white);\n            padding: var(--motes-padding) var(--safe-area-right) var(--motes-padding) var(--safe-area-left);\n\n            h3, .arrows-container {\n                margin: 5px 0;\n            }\n    \n            .arrows-container {\n                display: flex;\n                opacity: 1;\n    \n                // Align arrow icons horizontally within svg\n                svg-icon, svg-icon > span {\n                    display: flex;\n                    align-items: center;\n                }\n                \n                .arrow {\n                    font-size: 35px;\n                    margin: 0 2.5px;\n                    cursor: pointer;\n                }\n    \n                .arrow.disable {\n                    cursor: default;\n                    pointer-events: none;\n                    opacity: 0.5;        \n                }\n\n                &.hide {\n                    opacity: 0;\n                    pointer-events: none;\n                }\n            }\n        }\n    }\n    \n    // Mobile view\n    @media only screen and (max-width: 600px) {\n        --side-margin: var(--motes-padding);\n        --between-items-spacing: var(--motes-padding);\n\n        .horizontal-scroll {\n            mini-mote:hover {\n                transform: none;\n            }\n\n            .hbo-container .arrows-container {\n                display: none;\n            }\n\n            .scroll-container > *:only-child {\n                width: calc(100% - 2 * var(--side-margin));\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
